<template>
  <div class="study container">
      <el-input placeholder="请输入关键字快速检索" prefix-icon="el-icon-search" v-model="input" class="input-with-select" clearable @change = "doFilter" size="small">
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="检索全部" value="1"></el-option>
          <el-option label="车牌" value="2"></el-option>
          <el-option label="姓名" value="3"></el-option>
        </el-select>
      </el-input>

	      <el-date-picker
	        v-model="ny"
	        class='fr'
	        type="month"
          size="small"
          @change='loading=true;getStudy()'
	        placeholder="月份筛选">
	      </el-date-picker>

    <el-button style="float: right" id= "out" type="success" size="medium" round @click = "dialogFormVisible2 = true">批量导出</el-button>

    <div style="clear:both;"></div>
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        stripe
        :data="study.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          type="index"
          width="100"
          align="center">
        </el-table-column>

        <el-table-column
          prop="cph"
          label="车牌"
          sortable
          width="200px"
          align="center">
        </el-table-column>

        <el-table-column
          prop="name"
          label="姓名"
          align="center">
        </el-table-column>

        <el-table-column
          prop="danwei"
          label="单位"
          width="250"
          align="center">
        </el-table-column>

        <el-table-column
          :filters="nyf"
          :filter-method="filterNy"
          filter-placement="bottom-end"
          prop="ny"
          label="时间"
          align="center">
        </el-table-column>

        <el-table-column
          :filters="[{ text: '已通过', value: '已通过' }, { text: '待审核', value: '待审核' }, { text: '未通过', value: '未通过' }]"
          :filter-method="filterZt"
          filter-placement="bottom-end"
          prop="zt"
          label="状态"
          align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.zt === '已通过' ? 'success' : (scope.row.zt === '待审核' ? 'warning' : 'danger')"
              disable-transitions>{{scope.row.zt}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="详情" placement="right">
              <el-button type="primary" size="mini" icon="el-icon-more" @click="handleSh(scope.$index, scope.row)"></i></el-button>
            </el-tooltip>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

        <el-pagination
        v-show="pageshow"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100,1000]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>


    <el-dialog title="批量导出" :visible.sync="dialogFormVisible2" width="340px">

      <el-form :model="form2" :rules="rules2" ref="ruleForm2" status-icon>
        <el-form-item label="导出年月" :label-width="formLabelWidth" prop="ny">
          <el-select v-model="form2.ny" placeholder="请选择">
            <el-option
              v-for="item in nyitem"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2');">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog title="学习详情" :visible.sync="dialogFormVisible" width="1000px">

            <div style="text-align: right">
              <el-button v-if="form.zt!='未通过'" type="danger" @click="cancelForm('未通过');">不通过</el-button>
              <el-button v-if="form.zt!='未通过'" type="success" @click="submitForm('已通过');">通过审核</el-button>
            </div>

        <el-row :gutter="20">
          <el-col :span="7">
              <el-carousel :autoplay="false" type="card" height="220px">
                <el-carousel-item v-for="item in image" :key="item">
                  <img :src ="item" height="100%" width="100%" @click="openimg(item)"></img>
                </el-carousel-item>
              </el-carousel>
          </el-col>


          <el-col :span="3" style="text-align: center;">
            <img :src ="form.face" width="100px" @click="openimg(form.face)"></img>
            <el-button type="danger" size="mini" @click="handleretake">重拍</el-button>
          </el-col>

          <el-col :span="14">
            <el-table
              v-loading="loading"
              element-loading-text="加载中"
              :data="form.textlog"
              stripe
              show-summary
              style="width: 100%">
                <el-table-column
                  type="index"
                  width="80px"
                  align="center">
                </el-table-column>

                <el-table-column
                  prop="name"
                  label="标题"
                  align="center">
                </el-table-column>

                <el-table-column
                  prop="time"
                  label="时间(分钟)"
                  width = "100px"
                  align="center">
                </el-table-column>

            </el-table>

          </el-col>


        </el-row>

    </el-dialog>

    <el-dialog
          :visible.sync="innerVisible"
          append-to-body>
          <img :src ="src" height="100%" width="100%"></img>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    computed:{
      study(){
        return (this.dw.length > 0) ? this.dw : this.$store.state.study;
      },
      dw(){
        return this.$store.getters.getStudy(this.input,this.select);
      },
      total(){
        return this.study.length;
      },
      pageshow(){
        return this.total > 0;
      },
      nyf(){
        return this.$store.state.nyf;
      },
      nyitem(){
        return this.$store.state.ny;
      },
    },
    data(){
      var checkNy = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请选择分类'));
        } else {
          callback();
        }
      };
      return{
        src:'',
        ny:new Date(),
        image:[],
        input: '',
        select: "1",
        pagesize:100,
                currentPage:1,//默认开始页面
        loading: true,
        innerVisible:false,
            dialogFormVisible: false,
            dialogFormVisible2: false,
            form: {
              id:0,
              xyid:0,
              name: '',
              ny:'',
              studylog:[],
              textlog:[],
              zt: '',
              face:''
            },
            form2: {
                ny: '',
            },
            formLabelWidth: '120px',
        rules:{
              name: [
                { required: true, message: '请填写单位名称', trigger: 'blur' },
              ]
        },
        rules2:{
              ny: [
                { validator:checkNy, trigger: 'change' }
              ]
        }
      }
    },
    components:{
    },
    methods:{
      filterNy(value, row) {
        return row.ny === value;
      },
      filterZt(value, row) {
        return row.zt === value;
      },
      openimg(src){
        this.innerVisible=true;
        this.src = src;
      },
      doFilter(val) {
        if (this.dw.length == 0) this.$message({showClose: true,message: '没有找到包含【'+val+'】的内容',type: 'warning'});
      },
      handleSizeChange(val) {
        this.pagesize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      cancelForm(zt){
        this.$confirm('此操作不可逆 并删除已记录的照片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delPic(zt);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      handleretake(){
        this.$confirm('是否通知用户重拍头像?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.retake();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      retake(zt) {
          this.$message({showClose: true,message: '提交中……'});
          var params = new URLSearchParams();
          params.append('token', 'eqgU1wqtfzcZRAniU');
          params.append('admin', this.$store.getters.name);
          params.append('my', this.$store.getters.token);
          params.append('id', this.form.xyid);
          this.$ajax.post("/apis/xueyuan.php",params).then((ret) => {
              if (ret.data == true) this.$message({showClose: true,message: '操作成功',type: 'success'});
              else this.$notify.error({title: '错误',message: ret.data});
          }).catch(err=>{
              console.log(err)
              this.$notify.error({title: '错误',message: '网络异常'});
          });
      },
      delPic(zt) {
          this.dialogFormVisible = false;
          this.loading = true;
          var params = new URLSearchParams();
          params.append('token', 'dqgU1wqtfzcZRAniU');
          params.append('admin', this.$store.getters.name);
          params.append('my', this.$store.getters.token);
          params.append('ny', this.form.ny);
          params.append('xyid', this.form.xyid);
          this.$ajax.post("/apis/study.php",params).then((ret) => {
              // console.log(ret)
              this.submitForm(zt);
          }).catch(err=>{
            console.log(err)
              this.$notify.error({title: '错误',message: '网络异常'});
              this.loading = false;
          });
      },
      submitForm(zt) {
          this.form.zt = zt;
          this.$message({showClose: true,message: '提交中……'});
          this.dialogFormVisible = false;
          this.loading = true;
          var params = new URLSearchParams();
          params.append('token', 'gqgU1wqtfzcZRAniU');
          params.append('admin', this.$store.getters.name);
          params.append('my', this.$store.getters.token);
          params.append('zt', this.form.zt);
          params.append('id', this.form.id);
          this.$ajax.post("/apis/study.php",params).then((ret) => {
              console.log(ret)
              this.loading = false;
              if (ret.data == true) {
                this.$store.commit('editStudy',this.form);
                this.$message({showClose: true,message: '操作成功',type: 'success'});
              }else this.$notify.error({title: '错误',message: ret.data});
          }).catch(err=>{
            console.log(err)
              this.$notify.error({title: '错误',message: '网络异常'});
              this.loading = false;
          });
      },
      submitForm2(formName) {

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message({showClose: true,message: '提交中……'});
            this.dialogFormVisible2 = false;

            var params = new URLSearchParams();
            params.append('token', 'sqgU1wqtfzcZRAniU');
            params.append('admin', this.$store.getters.name);
            params.append('my', this.$store.getters.token);
            params.append('ny', this.form2.ny);
            this.$ajax.post("/apis/doc.php",params).then((ret) => {
                console.log(ret)
                if (ret.data.msg == true) {
                  this.$message({showClose: true,message: '导出成功,请查看下载',type: 'success'});
                  window.location = ret.data.src;
                }else this.$notify.error({title: '错误',message: ret.data});
            }).catch(err=>{
              console.log(err)
                this.$notify.error({title: '错误',message: '网络异常'});
            });



          } else {
            this.$message({showClose: true,message: '导出年月未选择',type: 'warning'});
            return false;
          }
        });

      },
      handleSh(i,r){
          // console.log(r);
          var params = new URLSearchParams();
          params.append('token', 'qqgU1wqtfzcZRAniU');
          params.append('admin', this.$store.getters.name);
          params.append('my', this.$store.getters.token);
          params.append('xyid', r.xyid);
          params.append('ny', r.ny);
          this.$ajax.post("/apis/study.php",params).then((ret) => {
                 // console.log(ret.data);
                // this.loading = false;
                if (ret.data !== false) {
                  this.image = ret.data;
                }else this.$notify.error({title: '未找到照片',message: ret.data});
          }).catch(err=>{
             console.log(err);
              this.$notify.error({title: '错误',message: '网络异常'});
              this.loading = false;
          });


        this.dialogFormVisible = true;
        this.form.id = r.id;
        this.form.name = r.name;
        this.form.xyid = r.xyid;
        this.form.ny = r.ny;
        this.form.zt = r.zt;
        this.form.studylog = r.studylog;
        this.form.textlog = this.$store.getters.getTextlog(r.studylog);
        this.form.face = this.$store.getters.getFace(r.xyid);
      },
      handleDelete(i,r){
            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {



              this.loading = true;
              this.$message({showClose: true,message: '删除中……'});

              var params = new URLSearchParams();
              params.append('token', 'dqgU1wqtfzcZRAniU');
              params.append('admin', this.$store.getters.name);
              params.append('my', this.$store.getters.token);
              params.append('ny', this.form.ny);
              params.append('xyid', this.form.xyid);
              this.$ajax.post("/apis/study.php",params).then((ret) => {

                  var params = new URLSearchParams();
                  params.append('token', 'sqgU1wqtfzcZRAniU');
                  params.append('admin', this.$store.getters.name);
                  params.append('my', this.$store.getters.token);
                  params.append('id', r.id);
                  this.$ajax.post("/apis/study.php",params).then((ret) => {
                            this.loading = false;
                            if (ret.data == true) {
                              this.$store.commit('delStudy', r);
                              this.$message({showClose: true,type: 'success',message: '删除成功!'});
                            }else this.$notify.error({title: '错误',message: ret.data});
                  }).catch(err=>{
                      this.$notify.error({title: '错误',message: '网络异常'});
                      this.loading = false;
                  });

              }).catch(err=>{
                console.log(err)
                  this.$notify.error({title: '错误',message: '网络异常'});
                  this.loading = false;
              });



            }).catch(() => {
              this.$message({showClose: true,type: 'info',message: '已取消'});
            });
      },
      tableRowClassName({row, rowIndex}) {
        return '';
      },
      getStudy(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('ny', this.ny.Format('yyyyMM'));
        this.$ajax.post("/apis/study.php",params).then((ret) => {
              // console.log(ret.data);
              this.loading = false;
              if (ret.data != "token错误" && ret.data != "数据库连接失败") {
                this.$store.commit('setStudy', ret.data.sort(this.compare));
              }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      },
      compare(v1, v2){
        if (Number(v1.id) < Number(v2.id)){
          return 1;
        }else if (Number(v1.id) > Number(v2.id)){
          return -1;
        }else{
          return 0;
        }
      }
    },
    created(){
      if (this.dw.length == 0) this.getStudy();
      else this.loading = false;
    }
  }
</script>

<style scoped>


  .el-pagination{
      display: flex;
      justify-content:center;
      align-items:center;
  }
  .el-select {
    width: 150px;
  }
  .el-input {
    width: 500px;
  }
  .fr{
   width: 200px !important;
 }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    float: left;
  }

/*  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
*/
  .el-carousel__item img{
        margin:0 auto;display:block
  }
</style>



// WEBPACK FOOTER //
// src/components/Sh.vue